// ANGULAR MODULES
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// OTHER MODULES
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AngularMaterialModule } from '../../shared/angular-material/angular-material.module';
import { MainRoutingModule } from './main-routing.module';
import { LoadingModule } from 'src/app/shared/components/loading/loading.module';
import { FeatherIconsModule } from 'src/app/shared/feather-icons/feather-icons/feather-icons.module';
import { SwitchDashboardModule } from './components/toolbar/switch-dashboard/switch-dashboard.module';

// SERVICES
import { InterceptorService } from '../../core/http/interceptor.service';

// COMPONENTS
import { MainLayoutComponent } from './main-layout.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { GlobalSearchComponent } from './components/toolbar/global-search/global-search.component';
import { NotificationsComponent } from './components/toolbar/notifications/notifications.component';
import { CloseEventsComponent } from './components/close-events/close-events.component';
import { CardEventComponent } from './components/close-events/card-event/card-event.component';
import {
  ToastTypesComponent,
  ToastSuccessComponent,
  ToastWarningComponent,
  ToastErrorComponent
} from './components/toast-types/toast-types.component';
import { ChatComponent } from './components/chat/chat.component';
import { MessagesHandlerComponent } from './components/chat/components/messages-handler/messages-handler.component';
import { ConversationComponent } from './components/chat/components/conversation/conversation.component';
import { EtaReminderComponent } from '@shared/components/eta-reminder/eta-reminder.component';
// DIRECTIVES
import { SidebarAnchorToggleDirective } from './components/sidenav/directives/sidebaranchortoggle.directive';
import { SidebarDirective } from './components/sidenav/directives/sidebar.directive';
import { SidebarLinkDirective } from './components/sidenav/directives/sidebarlink.directive';
import { SidebarListDirective } from './components/sidenav/directives/sidebarlist.directive';
import { SidebarToggleDirective } from './components/sidenav/directives/sidebartoggle.directive';

// PIPES
import { GetUserConversationPipe } from './components/chat/pipes/get-user-conversation.pipe';
import { GetUserPhotoPipe } from './components/chat/pipes/get-user-image.pipe';
import { PipesModule } from '@shared/pipes/pipes.module';
import { GlobalSearchService } from '@shared/services/global-search.service';
import { GlobalSearchTranslatorPipe } from '@shared/pipes/globall-search-translator.pipe';
import { ShortActionsComponent } from './components/toolbar/short-actions/short-actions.component';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { GetRecentContactsPipe } from './components/chat/pipes/get-recent-contacts.pipe';
import { DownloadReportsComponent } from './components/toolbar/download-reports/download-reports.component';
import { SessionStorageService } from 'src/app/main/orders/services/session-storage.service';

@NgModule({
  declarations: [
    MainLayoutComponent,
    ToolbarComponent,
    SidenavComponent,
    SidebarAnchorToggleDirective,
    SidebarDirective,
    SidebarLinkDirective,
    SidebarListDirective,
    SidebarToggleDirective,
    GlobalSearchComponent,
    NotificationsComponent,
    CloseEventsComponent,
    CardEventComponent,
    ToastTypesComponent,
    ToastSuccessComponent,
    ToastWarningComponent,
    ToastErrorComponent,
    ChatComponent,
    MessagesHandlerComponent,
    ConversationComponent,
    GetUserConversationPipe,
    GetUserPhotoPipe,
    ShortActionsComponent,
    GetRecentContactsPipe,
    DownloadReportsComponent,
    EtaReminderComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    MainRoutingModule,
    LoadingModule,
    PerfectScrollbarModule,
    FeatherIconsModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SwitchDashboardModule,
    PipesModule,
    NgxLinkifyjsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    DatePipe,
    GlobalSearchService,
    GlobalSearchTranslatorPipe,
    SessionStorageService
  ],
  entryComponents: [
    CloseEventsComponent,
    ToastSuccessComponent,
    ToastWarningComponent,
    ToastErrorComponent,
    DownloadReportsComponent,
    EtaReminderComponent
  ]
})
export class MainLayoutModule {}
